//import FR from '../lng/fr.js'
//import EN from '../lng/en.js'

import {mapGetters} from 'vuex'

const Langue = {
    install(Vue) {
        //Vue.prototype.$LA = this.$store.getters.getLanguage

        //Pour choisir la langue
        Vue.prototype.$L = function() {
            if (this.$store.getters.getLanguage == 'fr') {
                return 'Francais'//FR.Accueil
            }
            else if (this.$store.getters.getLanguage == 'en') {
                return 'Anglais'//EN.Accueil
            }
        }

        Vue.prototype.$TT = function() {
            return this.$store.getters.getLanguage
         }
        //STL = Select text language
        Vue.prototype.$STL =  function(txt) {
            if (this.$store.getters.getLanguage == 'fr')
                {return txt + 'Fr'}
            else
                {return txt + 'En'}
        }
        //STLdb = Select text language from Database
        Vue.prototype.$STLdb =  function() {
            if (this.$store.getters.getLanguage == 'fr')
                {return 'Fr'}
            else
                {return 'En'}
        }
    },
    computed: {
        ...mapGetters(["getLanguage"]),
    }
}
    
export default Langue